import DataSourceTypeDetailDto from "./DataSourceTypeDetailDto";

class DataSourceDetailDto {
    public Id: number;
    public Name: string;
    public Type: DataSourceTypeDetailDto;
    public ConnectorType: number;
    public CreatedById: number;
    public CustomerAgentId: number | null;
    public Parameters: Record<string, any>;

    constructor(
        id: number,
        name: string,
        type: DataSourceTypeDetailDto,
        connectorType: number,
        createdById: number,
        customerAgentId: number | null,
        parameters: Record<string, any>
    ) {
        this.Id = id;
        this.Name = name;
        this.Type = type;
        this.ConnectorType = connectorType;
        this.CreatedById = createdById;
        this.CustomerAgentId = customerAgentId;
        this.Parameters = parameters;
    }
}

export default DataSourceDetailDto;
